import { Routes } from "@angular/router";
import { loadTranslationResolver } from "@kernel/translations/resolvers/load-translations.resolver";
import { TRANSLATION_PATHS } from "@shared/general/translation/constants/translation.constant";
import { AuthGuard } from "@shared/auth/guards/auth.guard";
import { COMMON_GUARD_OPTIONS } from "@shared/auth/constants/permissions.constant";
import { SettingsRoutePaths } from "@shared/settings/settings-route-paths";
import { NotificationSettingsRoutePaths } from "./domains/notification-settings/notification-settings-route-path";
import { ExpirationSettingsRoutePaths } from "./domains/expiration-settings/expiration-settings-route-path";

export const settingRoutes: Routes = [
  {
    path: SettingsRoutePaths.CUSTOMER_TYPE,
    loadChildren: () => import("./domains/customer-type/customer-type.routing").then(r => r.customerTypeRoutes),
    resolve: {
      translate: loadTranslationResolver(TRANSLATION_PATHS.CUSTOMER_TYPE),
    },
  },
  {
    path: SettingsRoutePaths.INDUSTRY_SECTOR,
    loadChildren: () => import("./domains/industry-sector/industry-sector.routes").then(r => r.industrySectorRoutes),
    resolve: {
      translate: loadTranslationResolver(TRANSLATION_PATHS.INDUSTRY_SECTOR),
    },
  },
  {
    path: SettingsRoutePaths.PRODUCT,
    loadChildren: () => import("./domains/product/product.routes").then(r => r.productRoutes),
    resolve: {
      translate: loadTranslationResolver(TRANSLATION_PATHS.PRODUCT),
    },
  },
  {
    path: SettingsRoutePaths.RENTAL_HOUSE_SETTINGS,
    loadChildren: () => import("./domains/rental-house-settings/rental-house-settings.routes").then(r => r.rentalHouseSettingsRoute),
    resolve: {
      translate: loadTranslationResolver(TRANSLATION_PATHS.SETTINGS.RENTAL_HOUSE_SETTINGS),
    },
  },
  {
    path: SettingsRoutePaths.DYNAMIC_FIELD,
    loadChildren: () => import("./domains/dynamic-field/dynamic-field.routes").then(r => r.dynamicFieldRoutes),
    resolve: {
      translate: loadTranslationResolver([TRANSLATION_PATHS.SETTINGS.DYNAMIC_FIELDS, TRANSLATION_PATHS.FILE_TYPES]),
    },
  },
  {
    path: SettingsRoutePaths.VEHICLE_IMAGES,
    loadChildren: () => import("./domains/vehicle-images/vehicle-images.routes").then(m => m.vehicleImagesSetting),
    resolve: {
      translate: loadTranslationResolver([TRANSLATION_PATHS.VEHICLE_IMAGES, TRANSLATION_PATHS.INFO_CAR]),
    },
  },
  {
    path: SettingsRoutePaths.VEHICLE_PRIORITY,
    loadChildren: () => import("./domains/vehicle-priority/vehicle-priority.routes").then(m => m.vehiclePriorityRoutes),
    resolve: {
      translate: loadTranslationResolver([TRANSLATION_PATHS.SETTINGS.VEHICLE_PRIORITY]),
    },
  },
  {
    path: "system-settings",
    resolve: {
      translation: loadTranslationResolver([
        TRANSLATION_PATHS.SETTINGS.SYSTEM_SETTINGS,
        TRANSLATION_PATHS.AUTHENTICATION.ROLES,
        TRANSLATION_PATHS.AUTHENTICATION.USERS,
      ]),
    },
    canActivate: [AuthGuard],
    data: { authGuardOptions: COMMON_GUARD_OPTIONS.SYSTEM_SETTINGS.VIEW },
    loadChildren: () => import("./domains/system-settings/system-settings.routes").then(m => m.systemSettingsRoutes),
  },
  {
    path: NotificationSettingsRoutePaths.ROOT,
    loadChildren: () => import("./domains/notification-settings/notification-settings.routes").then(m => m.notificationSettingsRoutes),
    resolve: {
      translation: loadTranslationResolver([
        TRANSLATION_PATHS.NOTIFICATION_SETTINGS,
        TRANSLATION_PATHS.QUOTATION.QUOTATION_NOTIFICATION_SETTINGS,
        TRANSLATION_PATHS.STOCK_NOTIFICATION_SETTINGS,
      ]),
    },
  },
  {
    path: ExpirationSettingsRoutePaths.EXPIRATION_SETTINGS,
    loadChildren: () => import("./domains/expiration-settings/expiration-settings.routes").then(m => m.expirationSettingsRoutes),
    resolve: {
      translation: loadTranslationResolver([
        TRANSLATION_PATHS.EXPIRATION_SETTINGS.EXPIRATION_SETTINGS,
        TRANSLATION_PATHS.EXPIRATION_SETTINGS.STOCK_EXPIRATION_SETTINGS,
        TRANSLATION_PATHS.EXPIRATION_SETTINGS.OCR_QUOTATION_EXPIRATION_SETTINGS,
        TRANSLATION_PATHS.EXPIRATION_SETTINGS.QUOTATION_EXPIRATION_SETTINGS,
      ]),
    },
  },
];
